import { Grid2, Tab, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import TabPanel from "@mui/lab/TabPanel";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import { ClientDetailsPanel } from "./components/client-detailsPanel";
import { ClientCareInfoPanel } from "./components/client-careInfoPanel";
import { ClientMedicalInfoPanel } from "./components/client-medicalInfoPanel";
import { ClientContactPanel } from "./components/client-contactPanel";
import { ClientFileUploadPanel } from "./components/client-filePanel";
import { ClientLogPanel } from "./components/client-logPanel";
import { ClientFormPanel } from "./components/client-formPanel";
import { clientService } from "../../_services/client.service";
import { handleErrorResponse } from "../../_helpers/handleResponse.helper";

const tabListSx = {
    flex: 1,
    minWidth: 0,
    backgroundColor: "grey.100",
    borderRadius: 1,
    minHeight: 48,
    "& .MuiTabs-indicator": {
        display: "none",
    },
    "& .MuiTab-root": {
        flex: 1,
        minHeight: "48px",
        fontWeight: 500,
        borderRadius: 1,
        "&.Mui-selected": {
            backgroundColor: "primary.main",
            color: "white",
        },
    },
} as const;

export const ClientView = () => {
    const { clientId } = useParams<{ clientId: string }>();
    const [value, setValue] = useState("1");
    const [centreName, setCentreName] = useState("");

    useEffect(() => {
        if (!clientId) return;
        clientService.getLatest(clientId).then(
            (json) => setCentreName(json?.centreName ?? ""),
            handleErrorResponse
        );
    }, [clientId]);

    const handleChange = (event: React.SyntheticEvent, newValue: string) => {
        setValue(newValue);
    };

    return (
        <TabContext value={value}>
            <Grid2 container spacing={1} p={2}>
                <Grid2
                    size={{ xs: 12, md: 5 }}
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        minWidth: 0,
                    }}
                >
                    <Typography
                        component="div"
                        variant="subtitle1"
                        fontWeight={600}
                        sx={{
                            width: "100%",
                            minWidth: 0,
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            lineHeight: 1.2,
                        }}
                        title={centreName || undefined}
                    >
                        {centreName || "\u00a0"}
                    </Typography>
                </Grid2>
                <Grid2 size={{ xs: 12, md: 7 }} sx={{ display: "flex", alignItems: "center", minWidth: 0 }}>
                    <TabList onChange={handleChange} variant="fullWidth" sx={tabListSx}>
                        <Tab label="Client Contacts" value="1" />
                        <Tab label="Forms" value="2" />
                        <Tab label="Logs" value="3" />
                        <Tab label="Files" value="4" />
                    </TabList>
                </Grid2>

                <Grid2 size={{ xs: 12, sm: 4, md: 2.5 }}>
                    <ClientDetailsPanel />
                </Grid2>
                <Grid2 size={{ xs: 12, sm: 4, md: 2.5 }}>
                    <ClientCareInfoPanel />
                    <ClientMedicalInfoPanel />
                </Grid2>

                <Grid2 size={{ xs: 12, sm: 8, md: 7 }}>
                    <TabPanel value="1" sx={{ p: 0, mt: 0.55 }}>
                        <Grid2 container spacing={1}>
                            <Grid2 size={{ xs: 12, sm: 6, md: 12 }}>
                                <ClientContactPanel />
                            </Grid2>
                        </Grid2>
                    </TabPanel>
                    <TabPanel value="2" sx={{ p: 0, mt: 0.55 }}>
                        <Grid2 container spacing={1}>
                            <Grid2 size={{ xs: 12, sm: 6, md: 12 }}>
                                <ClientFormPanel />
                            </Grid2>
                        </Grid2>
                    </TabPanel>
                    <TabPanel value="3" sx={{ p: 0, mt: 0.55 }}>
                        <Grid2 container spacing={1}>
                            <Grid2 size={{ xs: 12, sm: 6, md: 12 }}>
                                <ClientLogPanel />
                            </Grid2>
                        </Grid2>
                    </TabPanel>
                    <TabPanel value="4" sx={{ p: 0, mt: 0.55 }}>
                        <Grid2 container spacing={1}>
                            <Grid2 size={{ xs: 12, sm: 6, md: 12 }}>
                                <ClientFileUploadPanel />
                            </Grid2>
                        </Grid2>
                    </TabPanel>
                </Grid2>
            </Grid2>
        </TabContext>
    );
};